import { render, staticRenderFns } from "./ToraCredentials.vue?vue&type=template&id=552c2688&scoped=true"
import script from "./ToraCredentials.vue?vue&type=script&lang=js"
export * from "./ToraCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552c2688",
  null
  
)

export default component.exports